(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.directive('extraDaysHolidaysTime', ['DayService', 'SchemeBroadcast', '$translate', ExtraDaysHolidaysTimeFn]);


    function ExtraDaysHolidaysTimeFn(DayService, SchemeBroadcast, $translate) {
        var directive = {
            link: link,
            restrict: 'E',
            replace: true,
            templateUrl: '/app/settings/agendasettings/modules/extradaysholidays/templates/time.html'
        };
        return directive;

        function link(scope, element) {

            var el = element.find('label');

            var bgClass = '';
            var bgFontClass = '';

            // first select 
            set();

            // element.on('mouseenter', function (event) {
            //     if (event.button === 0 && DayService.data.keyDown === true) {
            //         remove();
            //         DayService.select(scope.cell);
            //         set();
            //     } //if
            // });

            scope.dayClicked = function(event) {                
                if (event.button === 0) {
                    remove();
                    // DayService.data.keyDown = true;
                    DayService.select(scope.cell);
                    set();
                } 
            };

            // element.on('mouseup', function (event) {
            //     DayService.data.keyDown = false;
            // });

            // listener 
            var daySelectedHandler = scope.$on(SchemeBroadcast.DaySelected, function () {
                remove();
                set();
            });

            // remove classes
            function remove() {
                element.removeClass(bgClass);
                el.removeClass(bgFontClass);
                el.find('span').remove();
                bgClass = '';
                bgFontClass = '';
            } // set

            // set classes
            function set() {
                //// new classes
                if (scope.cell.agendaLabelDto !== null) {
                    bgClass = 'bg-' + scope.cell.agendaLabelDto.colorCaption;
                    bgFontClass = 'bg-font-' + scope.cell.agendaLabelDto.colorCaption;

                    element.addClass(bgClass);
                    el.addClass(bgFontClass);
                    
                    // add span
                    var labelText = scope.cell.agendaLabelDto.text || $translate.instant('label_without_caption');
                    var span = `<span 
                                    class="clearfix" style="font-size:x-small">
                                    ${labelText}
                                </span>`;
                    el.append(span);


                    scope.isHoliday = scope.cell.isHoliday || scope.cell.agendaLabelDto.isReadOnly;
                } // if  
            } // set          

            // on destroy
            scope.$on('$destroy', function () {                
                
                if (daySelectedHandler) {
                    daySelectedHandler();
                    daySelectedHandler = null;
                }
            });
        }
    }

})();